module.exports = __webpack_public_path__ + "bb7ae50c07af7775fc1931229542bcdb.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/02-Betsolutions-Plinko.png
// module id = 1724
// module chunks = 2